import { STREAM_UI_CONFIG } from '../../../../consts';

/** Shared HoverPopover props for appearance bars (pill popovers). */
export const personsTrackPopoverProps = {
  positionMode: 'cursor-x-element-y' as const,
  cursorOffset: { top: -12 },
  delay: STREAM_UI_CONFIG.trackPopoverDelayMs,
  contentSx: { p: 0, maxWidth: 'none' as const },
  paperSx: { minWidth: 300, maxWidth: 380 },
};

/** Shared HoverPopover props for cast cluster / overflow chrome. */
export const personsCastPopoverProps = {
  ...personsTrackPopoverProps,
  paperSx: { minWidth: 220, maxWidth: 320 },
};
